const TextInput = ({
  label, name, register, errors, validationRules = {},
  type = "text", placeholder = "", helpText = null, autoComplete = false, className = "", ...rest
}) => (
  <div className="mb-4 w-full">
    <label className='label label-text' htmlFor={name}>{label}</label>
    <input
      id={name}
      className={`input input-bordered w-full ${className}`}
      type={type}
      autoComplete={autoComplete.toString()}
      placeholder={placeholder}
      {...register(name, validationRules)}
      {...rest}
    />
    {helpText && (
      <p className="text-xs text-gray-500 mt-1">
        {helpText}
      </p>
    )}
    {errors[name] && (
      <label className="label">
        <span className="label-text-alt text-error">{errors[name].message}</span>
      </label>
    )}
  </div>
);

export default TextInput;
